export default __webpack_public_path__ + "static/media/p2.3affa682.png";